module.exports = __webpack_public_path__ + "img/default-browse-vehicles-with-images.9655e1b4.png";